export const types = {
  NO_CONNECTION_FOUND: 'NO_CONNECTION_FOUND'
};
